import type { ReactNode } from 'react';

import cn from '@/utils/cn';

export type ChipTone = 'success' | 'warning' | 'destructive' | 'info' | 'neutral';

const TONE_MAP: Record<ChipTone, string> = {
  success: 'bg-success-tint text-success border-success/30',
  warning: 'bg-warning-tint text-ink border-warning/40',
  destructive: 'bg-danger-tint text-ink border-danger/50',
  info: 'bg-brand-tint text-brand border-brand/30',
  neutral: 'bg-muted text-muted-foreground border-border',
};

// Sensible default tone per known status string when no explicit tone is given.
const STATUS_TONE: Record<string, ChipTone> = {
  'Not sent': 'neutral',
  'Not Paid': 'neutral',
  'Not Confirmed': 'warning',
  Confirmed: 'success',
  Lead: 'neutral',
  'Future Client': 'info',
  Client: 'success',
  'Partial Payment': 'warning',
  'Full Payment': 'success',
};

interface StatusChipProps {
  children: ReactNode;
  tone?: ChipTone;
}

export function StatusChip({ children, tone }: StatusChipProps) {
  const resolved: ChipTone =
    tone ?? (typeof children === 'string' ? (STATUS_TONE[children] ?? 'neutral') : 'neutral');
  return (
    <span
      className={cn(
        'inline-flex max-w-full items-center truncate whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-semibold sm:px-2.5 sm:text-xs',
        TONE_MAP[resolved],
      )}
    >
      {children}
    </span>
  );
}
